export const canViewRecognition = (
	isCustomer?: boolean,
	aiReviewSetting?: boolean,
	claims?: string[] | null
): boolean => {
	if (isCustomer === true) {
		return aiReviewSetting === true;
	}
	if (!claims?.length) {
		return false;
	}
	return (
		claims.includes('admin') ||
		claims.includes('reports:view') ||
		claims.includes('reports:created:view')
	);
};

export const canEditReportPhoto = (
	claims?: string[] | null,
	isCustomer?: boolean
): boolean => {
	if (isCustomer === true) {
		return false;
	}
	return !!(
		claims &&
		(claims.includes('admin') || claims.includes('reports:edit'))
	);
};

export const canDeleteReportPhoto = canEditReportPhoto;
